import { jsx as r } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import m from "@mui/material/ListItem";
import d from "styled-components";
const l = {
  root: "listItemRoot",
  dense: "listItemDense",
  gutters: "listItemGutters",
  divider: "listItemDivider",
  secondaryAction: "listItemSecondaryAction"
}, a = d(m).withConfig({
  displayName: "StyledListItem"
})([
  "&&.listItemRoot{min-height:50px;font-size:",
  ";color:",
  ";line-height:1.2em;background-color:",
  ";opacity:1;cursor:default;}&&.listItemRoot.listItemDense{min-height:34px;}&&.listItemGutters{padding-left:16px;padding-right:16px;}&&.listItemRoot.listItemSecondaryAction{padding-right:60px;}&&.listItemDivider{border-color:",
  ";}"
], ({ theme: t }) => t.typography.body200.fontSize, ({ theme: t }) => t.text.primary, ({ theme: t }) => t.primaryBackground, ({ theme: t }) => t.primaryBorder), n = /* @__PURE__ */ s(({ children: t, classes: e, ...i }, o) => /* @__PURE__ */ r(a, {
  ...i,
  ref: o,
  classes: {
    ...l,
    ...e
  },
  children: t
}));
n.displayName = "ListItem";
export {
  n as default
};
